import { Component, Vue, Prop, Emit, Watch } from 'vue-property-decorator';
import Modal from '@/assets/common/Modal/Modal.vue';
import { ChemicalModel } from '@/types/Component';


@Component({
    components: {
        Modal,
    }
})

export default class ChemicalMemoModal extends Vue {

    @Prop({ required: true }) value!: boolean;
    @Prop({ required: true, default: null }) chemical!: ChemicalModel | null;
    @Prop({ required: false, default: false }) isReadOnly!: boolean;

    originalMemo: string | null = null;
    altered = false;

    get showChemicalMemoModal(): boolean {
        return this.value;
    }

    @Watch('value', { immediate: true })
    onModalOpen(newVal: boolean) {
        if (newVal && this.chemical) {
            this.originalMemo = this.chemical.memo ?? null;
        }
    }

    @Emit('input')
    handleModal(cancel = false) {
        if (cancel && this.altered && !window.confirm("変更内容を破棄します。よろしいですか？")) return;
        if (this.chemical) this.chemical.memo = cancel ? this.originalMemo : (this.chemical.memo?.trim() || null);
        this.originalMemo = null;
        this.altered = false;
        return false;
    }
}